
import { Show, SimpleShowLayout, TextField, DateField, NumberField } from 'react-admin';

export const Tbl_teamShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <NumberField source="id" />
            <NumberField source="legaId" />
            <TextField source="nome" />
            <TextField source="note" />
            <NumberField source="flVisibile" />
            <NumberField source="flAttivo" />
            <NumberField source="flAnnullato" />
            <NumberField source="ordinamento" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
        </SimpleShowLayout>
    </Show>
);
            